export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";